module.exports = __webpack_public_path__ + "img/allo-logo.911fadee.png";